




import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GGroupEditValueCell',
  computed: {},
  methods: {},
})
export default class GGroupEditValueCell extends Vue {
  mounted() {}
}
